<template>
  <button :class="styled" :disabled="loading" type="button">
    <span v-if="loading">
      <span v-if="type_loader == 'spin-with-text'"
        ><span
          class="spinner-border spinner-border-sm mr-1"
          role="status"
          aria-hidden="true"
        ></span>
        Loading...</span
      >
      <span v-else
        ><span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span
      ></span>
    </span>
    <span v-else>
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: "ButtonLoader",
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    styled: {
      type: String,
      required: false,
      default: "btn btn-primary",
    },
    type_loader: {
      type: String,
      required: false,
      default: "spin-with-text",
    },
  },
};
</script>
